export default __webpack_public_path__ + "static/media/heartOutline.ccaeeef3.svg";